import { SubstateClaimReader, CadmakersApp, AppSubState } from "@cadmakers/auth";
import { IAppState } from "../../Common";
import { SubscriptionState } from "../Constants/applicationEnums";
import { AppSubscriptionClaimType } from "../Constants/authConstants";
import { appConstants } from "../Constants/appConstants";

interface IAppService {
  getApplicationSubStatesFromAppState(state: IAppState): Record<string, SubscriptionState>;
}

class AppService implements IAppService {
  getApplicationSubStatesFromAppState(state: IAppState): Record<string, SubscriptionState> {
    const appSubStates: Record<string, SubscriptionState> = {};
    if (state.oidc.user) {
      // look for claims which represent app subscriptions
      let isAdUser = false;

      // Read the claim value
      const subStateClaimReader = new SubstateClaimReader(
        state.oidc.user.profile[AppSubscriptionClaimType]
      );

      // Get enum values and loop through to create the app substate dictionary
      const cadmakersAppEnumValues = Object.keys(CadmakersApp)
        .filter(app => !Number.isNaN(Number(app)))
        .map(app => parseInt(app, 10));

      for (let i = 0; i < cadmakersAppEnumValues.length; i++) {
        const enumValue = cadmakersAppEnumValues[i];
        let appKey;
        switch (enumValue) {
          case CadmakersApp.Knowledge:
            appKey = appConstants.knowldgeAppRolePrefix;
            break;
          case CadmakersApp.IssueManager:
            appKey = appConstants.threadAppRolePrefix;
            break;
          case CadmakersApp.Viewer:
            appKey = appConstants.viewerAppRolePrefix;
            break;
          case CadmakersApp.Exe:
            appKey = appConstants.exeAppRolePrefix;
            break;
          case CadmakersApp.Feedback:
            appKey = appConstants.feedbackAppRolePrefix;
            break;
          case CadmakersApp.ProjectManager:
            appKey = appConstants.projectMAnagerAppRolePrefix;
            break;
          case CadmakersApp.Wiki:
            appKey = appConstants.wikiAppRolePrefix;
            break;
          case CadmakersApp.Builder:
            appKey = appConstants.builderAppRolePrefix;
            break;
          default:
            // eslint-disable-next-line no-continue
            continue;
        }

        let subState: SubscriptionState;

        const subscription = subStateClaimReader.getSubscription(enumValue);

        switch (subscription) {
          case AppSubState.Paid:
            subState = SubscriptionState.Active;
            break;
          case AppSubState.Trial:
            subState = SubscriptionState.Active;
            break;
          case AppSubState.CMActiveDirectory:
            subState = SubscriptionState.Active;
            isAdUser = true;
            break;
          case AppSubState.Expired:
            subState = SubscriptionState.Expired;
            break;
          case AppSubState.Overfull:
            subState = SubscriptionState.Overfull;
            break;
          default:
            subState = SubscriptionState.None;
        }

        appSubStates[appKey] = subState;
      }

      if (isAdUser) {
        // also add cmFeedback if we have an AD sub
        appSubStates[appConstants.feedbackAppRolePrefix] = SubscriptionState.Active;

        // also add cmToolbox if we have an AD sub
        appSubStates[appConstants.toolboxAppRolePrefix] = SubscriptionState.Active;

        // also add cmThreadV2 if we have an AD sub
        appSubStates[appConstants.threadV2AppRolePrefix] = SubscriptionState.Active;

        // also add wiki if we have an AD sub
        appSubStates[appConstants.wikiAppRolePrefix] = SubscriptionState.Active;

        // also add cmBuilder if we have an AD sub
        appSubStates[appConstants.builderAppRolePrefix] = SubscriptionState.Active;
      }
    }

    return appSubStates;
  }
}

export const appService: IAppService = new AppService();
